import React from "react";
import { makeStyles, Typography } from "@material-ui/core";

import PinkStroke from "./assets/pinkStroke.svg";
import GreenStroke from "./assets/greenStroke.svg";
import YellowStroke from "./assets/yellowStroke.svg";
import { formatPriceCents } from "./utils";

export default function ProductPrice({ price }) {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <div className={classes.priceContainer}>
        <Typography variant="h2" className={classes.price}>
          {formatPriceCents(price)}
        </Typography>
      </div>
      <div className={classes.tickContainer}>
        <PinkStroke />
        <YellowStroke />
        <GreenStroke />
      </div>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  priceContainer: {
    borderRadius: 50,
    padding: 7,
    paddingRight: 16,
    marginLeft: "auto",
    paddingLeft: 16,
    border: `2px solid ${theme.palette.secondary.main}`,
    boxShadow: `1px 2px ${theme.palette.secondary.main}`,
  },
  tickContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "12px",
    marginLeft: theme.spacing(),
  },
  price: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
  },
}));
